import { API_BASE_URL } from "@/config";
import { ENTERPRISE_CREDIT_CHECK, ENTERPRISE_TRANSUNION_KYB_ENQUIRY_REASON, KYB_CREDIT_CHECK_CODE } from "@/utils/constants.js";
import { format_business_registration_number } from "@/utils/validations.js";
import { useToast } from '@/components/Toast/useToast';

export default {
    name: 'EnterpriseTransUnionCreditCheckForm',
    setup() {
        const { showSuccess, showError } = useToast();
        
        return {
            showSuccess,
            showError
        };
    },
    data() {
        return {
            form: {
                registration_number: '',
            },
        };
    },
    emits: ['service_status_complete'],
    methods: {
        validate_registration_number(event) {
            const { formatted_input, new_cursor_position } = format_business_registration_number(event);

            // Update the registration number model
            this.form.registration_number = formatted_input;

            // Adjust the cursor position
            this.$nextTick(() => {
                event.target.selectionStart = new_cursor_position;
                event.target.selectionEnd = new_cursor_position;
            });
        },
        handle_submit() {
            if (!this.form.registration_number) {
                this.showError('Error', 'All fields are required.');
                return;
            }

            const string_fields = ['registration_number'];
            for (const field of string_fields) {
                if (typeof this.form[field] !== 'string' || !this.form[field].trim()) {
                    this.showError('Error', `Invalid input for ${field.replace('_', ' ')}. Please enter a valid string.`);
                    return;
                }
            }

            const TOKEN = localStorage.getItem('token');
            const ENTERPRISE_TRANSUNION_CREDIT_CHECK_API = `${API_BASE_URL}/verify_api/instant_verify_api/enterprise_kyb/`;

            this.error = '';

            // Remove slashes from the registration number
            const sanitized_registration_number = this.form.registration_number.replace(/\//g, '');

            $.ajax({
                url: ENTERPRISE_TRANSUNION_CREDIT_CHECK_API,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify({
                    registration_number: sanitized_registration_number,
                    enquiry_reason: ENTERPRISE_TRANSUNION_KYB_ENQUIRY_REASON,
                    product_list: KYB_CREDIT_CHECK_CODE,
                    service_name: ENTERPRISE_CREDIT_CHECK,
                }),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading(),
                    });
                },
                success: () => {
                    Swal.close();
                    this.showSuccess('Successful', 'Enterprise Credti Check ran successfully', 3000);
                    this.$emit('service_status_complete');
                    this.form.registration_number = '';
                },
                error: (error) => {
                    Swal.close();
                    let error_message = 'Something went wrong!';

                    if (error.responseJSON && error.responseJSON.message) {
                        error_message = error.responseJSON.message;
                    }

                    this.showError('Error', error_message);
                }
            });
        },
    }
};
